const DiseaseEncyclopediaGuideInfo = () => {
  return (
    <ul className='typography-ui-15r mx-[24px] flex flex-col gap-[8px] pb-[24px] pl-[20px] text-gray-400 marker:mr-[2px] marker:text-gray-400'>
      {[
        '해당 정보는 지식 제공을 위한 참고사항이며, 법적 책임이 발생하지 않습니다.',
        '질환 관련 의학적 조언이나 진단 등 전문적 소견이 필요하시다면, 의료진 등 전문가와 상담하시기 바랍니다.',
      ].map((item) => (
        <li
          key={item}
          className='relative cursor-none before:absolute before:top-[10px] before:left-[-13px] before:block before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-400 before:content-[""]'
        >
          {item}
        </li>
      ))}
    </ul>
  );
};

export default DiseaseEncyclopediaGuideInfo;
